import OAuthRoutes from "./OAuthRoutes";

export default OAuthRoutes;
